import { Amplify } from 'aws-amplify';

const cognitoConfig = {
  Auth: {
    region: process.env.REACT_APP_COGNITO_REGION,
    userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    userPoolWebClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_COGNITO_DOMAIN?.replace('https://', ''),
      scope: ['email', 'openid', 'profile'],
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGNIN,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGNOUT,
      responseType: 'code'
    }
  }
};

// Only configure Amplify if auth is enabled
if (process.env.REACT_APP_AUTH_ENABLED === 'true' && process.env.REACT_APP_COGNITO_USER_POOL_ID) {
  try {
    Amplify.configure(cognitoConfig);
    console.log('AWS Cognito configured successfully');
  } catch (error) {
    console.warn('Failed to configure AWS Cognito:', error);
  }
} else {
  console.log('AWS Cognito authentication disabled for local development');
}

export default cognitoConfig;